import type { Section } from '../sections';

// Line icons from the click demo, drawn on a 24px grid with the current text colour.
const SECTION_PATHS: Record<Section, React.JSX.Element> = {
  chat: <path d="M4 5h16v11H9l-5 4z" />,
  data: (
    <>
      <ellipse cx="12" cy="6" rx="7" ry="3" />
      <path d="M5 6v6c0 1.7 3.1 3 7 3s7-1.3 7-3V6" />
      <path d="M5 12v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6" />
    </>
  ),
  skills: <path d="M12 3l2.2 5.3L20 9l-4.4 3.9L17 19l-5-3-5 3 1.4-6.1L4 9l5.8-.7z" />,
  automations: (
    <>
      <rect x="5" y="8" width="14" height="11" rx="3" />
      <path d="M12 4v4M9.5 13.5h.01M14.5 13.5h.01" />
    </>
  ),
  approvals: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M8 12l3 3 5-6" />
    </>
  ),
  integrations: (
    <>
      <path d="M9 7V3M15 7V3M7 7h10v4a5 5 0 0 1-10 0z" />
      <path d="M12 16v5" />
    </>
  ),
  chats: <path d="M4 7h16M4 12h16M4 17h10" />,
};

function Icon({ size, strokeWidth, children }: { size: number; strokeWidth: number; children: React.ReactNode }): React.JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {children}
    </svg>
  );
}

export function SectionIcon({ section }: { section: Section }): React.JSX.Element {
  return (
    <Icon size={20} strokeWidth={1.8}>
      {SECTION_PATHS[section]}
    </Icon>
  );
}

export function PaperclipIcon(): React.JSX.Element {
  return (
    <Icon size={20} strokeWidth={1.8}>
      <path d="M20 11l-8 8a5 5 0 0 1-7-7l8-8a3.5 3.5 0 0 1 5 5l-8 8a2 2 0 0 1-3-3l7-7" />
    </Icon>
  );
}

export function SendIcon(): React.JSX.Element {
  return (
    <Icon size={18} strokeWidth={2.2}>
      <path d="M5 12h13M13 6l6 6-6 6" />
    </Icon>
  );
}

export function TrashIcon(): React.JSX.Element {
  return (
    <Icon size={20} strokeWidth={1.8}>
      <path d="M5 7h14M10 7V4h4v3M7 7l1 13h8l1-13" />
    </Icon>
  );
}

export function PlusIcon(): React.JSX.Element {
  return (
    <Icon size={18} strokeWidth={2.2}>
      <path d="M12 5v14M5 12h14" />
    </Icon>
  );
}
